export default __webpack_public_path__ + "static/media/san-rafael-9.39eaed46.jpg";